import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Sparkles, Compass, ShieldCheck } from 'lucide-react';

const VisionStatement = () => {
    return (
        <section className="relative py-20 px-4 overflow-hidden">
            {/* Soft Gradient Background Glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-purple-100/30 blur-[120px] rounded-full z-0" />

            <div className="max-w-5xl mx-auto relative z-10">
                <motion.div 
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    className="bg-white/60 backdrop-blur-md border border-white rounded-[3rem] p-8 md:p-16 shadow-2xl shadow-purple-200/40 text-center"
                >
                    {/* Header with Icon */}
                    <div className="flex flex-col items-center mb-10">
                        <div className="p-4 bg-purple-600 text-white rounded-2xl shadow-lg shadow-purple-200 mb-6 transition-transform hover:rotate-3">
                            <Eye className="w-8 h-8" />
                        </div>
                        <h2 className="text-[10px] font-bold uppercase tracking-[0.5em] text-purple-600 mb-2">The Vision</h2>
                        <h3 className="text-3xl md:text-5xl font-serif font-bold text-slate-900 italic">
                            A Future Focused on <span className="text-purple-700">Eternity</span>
                        </h3>
                    </div>

                    {/* Main Statement */}
                    <motion.div 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                        className="relative"
                    >
                        {/* Quote Mark Decoration */}
                        <span className="absolute -top-6 -left-2 text-8xl text-purple-100 font-serif leading-none select-none">“</span>
                        
                        <p className="text-xl md:text-2xl text-slate-700 font-serif leading-relaxed max-w-3xl mx-auto">
                            <span className="font-bold text-slate-900">Ibadan South Diocese</span> shall be <br className="hidden md:block" />
                            <span className="inline-block px-2 bg-purple-50 text-purple-800 rounded-md font-medium">Bible-Based</span>, 
                            <span className="inline-block px-2 bg-purple-50 text-purple-800 rounded-md font-medium mx-1">God-centered</span>, and 
                            <span className="inline-block px-2 bg-purple-50 text-purple-800 rounded-md font-medium">Holy Spirit-Guided</span>. 
                            We are committed to pragmatic evangelism, preparing men and women to joyfully meet our Lord Jesus Christ at His second coming.
                        </p>

                        <span className="absolute -bottom-16 -right-2 text-8xl text-purple-100 font-serif leading-none select-none rotate-180">“</span>
                    </motion.div>

                    {/* The Pillars of the Vision */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-20 pt-12 border-t border-purple-50">
                        <div className="flex flex-col items-center group">
                            <Sparkles className="w-5 h-5 text-purple-400 mb-3 group-hover:text-purple-600 transition-colors" />
                            <h4 className="text-xs font-bold uppercase tracking-widest text-slate-400 group-hover:text-slate-900 transition-colors">Pragmatic</h4>
                            <p className="text-[10px] text-slate-400 italic">Evangelism in action</p>
                        </div>
                        <div className="flex flex-col items-center group border-y md:border-y-0 md:border-x border-purple-50 py-4 md:py-0">
                            <Compass className="w-5 h-5 text-purple-400 mb-3 group-hover:text-purple-600 transition-colors" />
                            <h4 className="text-xs font-bold uppercase tracking-widest text-slate-400 group-hover:text-slate-900 transition-colors">Guidance</h4>
                            <p className="text-[10px] text-slate-400 italic">Spirit-Led direction</p>
                        </div>
                        <div className="flex flex-col items-center group">
                            <ShieldCheck className="w-5 h-5 text-purple-400 mb-3 group-hover:text-purple-600 transition-colors" />
                            <h4 className="text-xs font-bold uppercase tracking-widest text-slate-400 group-hover:text-slate-900 transition-colors">Readiness</h4>
                            <p className="text-[10px] text-slate-400 italic">Prepared for the King</p>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default VisionStatement;